<template>
  <v-card
    :wxid="$options.name"
    :class="{ disabled: isTileDisabled, unfocused: isTileUnfocused }"
    class="tile all-products-quantity unit-name"
    tag="section"
    sf="1"
  >
    <grouped-tile-selector-menu :tile-index="tileIndex" />
    <div class="tile-inner">
      <h3 :title="title" class="primary-title">
        {{ title }}
        <v-icon v-if="!isTileAuthorized()">mdi-lock</v-icon>
      </h3>
      <h2 class="primary-value">{{ primaryValue }}</h2>
      <p v-if="noConversionFound" class="value-sub-text__unit font-italic">{{ $t("tiles.noConversionNote") }}</p>
      <p v-else class="value-sub-text__unit label">{{ unitName }}</p>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ProductionUnitService from "@/components/productionunit/ProductionUnitService";
import GroupedTileSelectorMenu from "@/components/dashboard/tiles/GroupedTileSelectorMenu";
import TileBase from "@/components/dashboard/tiles/TileBase";
import Tiles from "@/components/Tiles";
import Helpers, { dash } from "@/helpers";
import TileService from "@/components/dashboard/tiles/TileService";
import { getUnitName } from "@/components/dashboard/tileselectormenu/TileHelper";
import UnitConversionWarningMixin from "@/components/dashboard/tiles/UnitConversionWarningMixin";

export default {
  name: "TileAllProductsQuantity",
  extends: TileBase,
  inheritAttrs: false,
  mixins: [UnitConversionWarningMixin],
  components: { GroupedTileSelectorMenu },
  computed: {
    ...mapGetters("dashboard", ["productionUnitConvertedUnit", "allProductsQuantity", "activeProductionUnitId"]),
    ...mapGetters("packages", ["activePuHasRequiredFeature"]),
    ...mapGetters("tiles", ["selectedTileIndex"]),
    ...mapGetters("user", ["preferences"]),
    isTileUnfocused() {
      return this.selectedTileIndex !== null && this.tileIndex !== this.selectedTileIndex;
    },
    isTileDisabled() {
      return !this.isTileAuthorized();
    },
    title() {
      return this.$t("tiles.totalLineQuantity");
    },
    unit() {
      const tile = TileService.getDashboardTile(this.activeProductionUnitId, this.tileIndex, this.preferences);
      return tile?.config?.product_unit ?? null;
    },
    unitName() {
      const unitName = this.unit
        ? getUnitName(this.unit).name
        : ProductionUnitService.getUnitName(this.productionUnitConvertedUnit);
      if (this.productionUnitConvertedUnit && this.isTileAuthorized()) {
        return unitName;
      } else {
        return "";
      }
    },
    // Product Quantity
    value() {
      return this.allProductsQuantity(this.unit);
    },
    primaryValue() {
      return this.value && this.isTileAuthorized() ? Helpers.round(this.allProductsQuantity(this.unit), 1) : dash;
    },
  },
  methods: {
    isTileAuthorized() {
      return this.activePuHasRequiredFeature(Tiles.allProductsQuantity.requiredFeature);
    },
  },
};
</script>
